// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".topbar .dropdown-toggle {\n  padding: 0;\n}\n.topbar .dropdown-toggle:hover {\n  text-decoration: none;\n}\n.topbar .dropdown-toggle.dropdown-toggle-no-caret:after {\n  content: none;\n}\n.topbar .dropdown-menu {\n  margin: 0;\n  padding: 0;\n  outline: none;\n}\n.topbar .dropdown-menu .b-dropdown-text {\n  padding: 0;\n}", ""]);
// Exports
module.exports = exports;
